export default {
  persistErrorsOnLocationChange: 'persistErrorsOnLocationChange',
};
